module.exports = __webpack_public_path__ + "img/GAME_QUIZNORI2.ecce7f6d.jpg";